export type Mode = 'VIEW' | 'COMPARE';

export const MODES: {[k in Mode]: Mode} = {
  VIEW: 'VIEW',
  COMPARE: 'COMPARE',
};

// Some places are importing this file directly, so we keep supporting that.
export default MODES;
